import { createSelector } from "reselect";
import get from "lodash/get";
import map from "lodash/map";
import range from "lodash/range";
import memoize from "lodash/memoize";
import forEach from "lodash/forEach";
import { DEFAULT_LOCALE } from "utils/constants";
import { getItem, getLocaleOrDefault, setItem } from "utils/localStorage";
export const localeDomain = state => get(state.api, "locale.data", {});
export const appSettingsLocale = state =>
  get(state, "api.appSettings.data.locale", []);

// ***************************************************************
// ********************** locale makeSelect **********************
// ***************************************************************

export const localeSelector = createSelector(localeDomain, locale => locale);

export const dateOptionsSelector = createSelector(localeDomain, localeState => {
  return map(range(31), n => {
    let paddedValue = (n + 1).toString().padStart(2, "0");
    const string = localeState[`date_${paddedValue}`];

    return {
      label: string,
      value: paddedValue
    };
  });
});

export const monthOptionsSelector = createSelector(
  localeDomain,
  localeState => {
    return map(range(12), n => {
      let paddedValue = (n + 1).toString().padStart(2, "0");
      const string = localeState[`month_short_${paddedValue}`];

      return {
        label: string,
        value: paddedValue
      };
    });
  }
);

export const genericErrorSelector = createSelector(localeDomain, locales =>
  get(locales, "ERROR_GENERIC_MESSAGE", "")
);

export const errorSelectorByKey = createSelector(localeDomain, locales =>
  memoize(key => get(locales, key))
);

export const enabledLocaleSelector = createSelector(
  appSettingsLocale,
  result => {
    const urlPath = new URL(window.location.href);
    const userlang = [];
    const languages = get(result, "result.languages", []);
    let defaultLangInConfig = null;
    if (getItem("MobileLangCode") && getItem("MobileLangCode") !== "null") {
      setItem("locale", getItem("MobileLangCode"));
      setItem("userLocale", getItem("MobileLangCode"));
    }
    if (getItem("userLocale") && getItem("userLocale") !== "null") {
      setItem("locale", getItem("userLocale"));
      setItem("userLocale", getItem("userLocale"));
    }
    forEach(languages, eachlocalLanguage => {
      let selectedLang = false;
      if (
        eachlocalLanguage.default &&
        (!getItem("userLocale") || getItem("userLocale") === "null") &&
        urlPath.href.indexOf("langCode") === -1
      ) {
        setItem("locale", eachlocalLanguage.locale);
        /*!getUserLocale()*/ defaultLangInConfig = eachlocalLanguage.locale;
      }
      eachlocalLanguage.locale === getItem("locale") || DEFAULT_LOCALE
        ? (selectedLang = true)
        : (selectedLang = false);
      if (eachlocalLanguage.enabled) {
        userlang.push({
          label: eachlocalLanguage.label,
          value: eachlocalLanguage.locale,
          selected: selectedLang
        });
      }
    });
    if (!defaultLangInConfig) {
      getLocaleOrDefault();
    }
    return userlang;
  }
);

export const makeSelectLocale = () => localeSelector;
export const makeSelectMessages = () => localeSelector;
export const makeSelectDateOptions = () => dateOptionsSelector;
export const makeSelectMonthOptions = () => monthOptionsSelector;
export const makeSelectGenericErrorSelector = () => genericErrorSelector;
export const makeSelectEnabledLocale = () => enabledLocaleSelector;
